import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EntryGuideForm from '../../components/EntryGuides/EntryGuideForm';
import Toast from '../../components/Common/Toast';

const CreateReceptionGuide = () => {
  const navigate = useNavigate();
  const { warehouseId } = useParams();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({ isOpen: true, message: 'Guía de recepción creada exitosamente', type: 'success' });
    setTimeout(() => {
      navigate(`/warehouses/${warehouseId}/documents`);
    }, 1500);
  };

  const handleCancel = () => {
    navigate(`/warehouses/${warehouseId}/documents`);
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva Guía de Recepción</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear una nueva guía de recepción</p>
        </div>
        <EntryGuideForm
          isOpen={true}
          onClose={handleCancel}
          entryGuide={null}
          warehouseId={warehouseId}
          onSuccess={handleSuccess}
          isPageMode={true}
          isReception={true}
        />
        <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
      </div>
    </div>
  );
};

export default CreateReceptionGuide;

